<template>
  <q-btn
    :type="type"
    :color="color"
    :text-color="textColor"
    :label="label"
    :flat="flat"
    :dense="dense"
    :outline="outline"
    :round="!label && !!icon"
    :rounded="rounded"
    :icon="icon"
    :icon-right="iconRight"
    :size="size"
    :disable="disable"
    :loading="loading"
    unelevated
    no-caps
    @click="$emit('click')"
  >
    <q-tooltip
      ref="tooltip"
      :anchor="currentPosition.anchor"
      :self="currentPosition.self"
      :delay="tooltipDelay"
      v-if="tooltip"
    >
      {{ tooltip }}
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    label: String,
    color: {
      type: String,
      default: 'primary',
      validator: (color) =>
        ['primary', 'secondary', 'tertiary', 'standard', 'neutral', 'warning', 'negative'].includes(
          color
        ),
    },
    flat: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    icon: String,
    iconRight: String,
    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: (size) =>
        ['xs', 'sm', 'md', 'lg', 'xl', 'small', 'medium', 'large'].includes(size),
    },
    tooltip: String,
    tooltipPosition: {
      type: String,
      default: 'bottom',
    },
    tooltipDelay: {
      type: Number,
      default: 500,
    },
  },
  watch: {
    loading(val) {
      if (this.tooltip) {
        if (val) this.$refs['tooltip'].show();
        else this.$refs['tooltip'].hide();
      }
    },
  },
  computed: {
    textColor() {
      return this.color === 'standard' ? 'black' : '';
    },

    currentPosition() {
      const positionStyle = {
        top: { anchor: 'top middle', self: 'bottom middle' },
        bottom: { anchor: 'bottom middle', self: 'top middle' },
        right: { anchor: 'center right', self: 'center left' },
      };

      return positionStyle[this.tooltipPosition] || positionStyle['top'];
    },
  },
};
</script>
